import React from "react";
import ScoreBar from "./ScoreBar";
import info_mark from "../img/info_mark.svg";
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip } from "react-tooltip";

interface ScoreCardProps {
  id: string;
  hits: number;
  total: number;
  text: string;
  color: string;
  tooltip_text: string;
}

const ScoreCard: React.FC<ScoreCardProps> = ({
  id,
  hits,
  total,
  text,
  color,
  tooltip_text,
}) => {
  const [percentage, setPercentage] = React.useState<number>(0);

  React.useEffect(() => {
    setPercentage((hits / total) * 100);
  }, [hits, total]);

  return (
    <div className={`${id}`}>
      <div className="items-right flex flex-col justify-end pr-2 lg:pr-4">
        <div className="flex w-full flex-row justify-between pt-2">
          <h3 className="text-light flex flex-row text-right font-code text-lg font-bold md:text-lg">
            {text}
          </h3>
          <h3
            className={`text-light text-left font-code text-lg font-bold 2xl:text-right ${
              total === 0 ? "hidden" : ""
            }`}
          >
            <span className="text-orange font-bold ">{hits}</span> out of{" "}
            <span className="text-blue font-bold">{total}</span>
          </h3>
        </div>
        <ScoreBar progress={total === 0 ? 0 : percentage} color={color} />
      </div>
      <Tooltip anchorSelect={`.${id}`} className="font-code" place="top">
        {tooltip_text}
      </Tooltip>
    </div>
  );
};

export default ScoreCard;
